import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDownCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.3107L7.68934 13L8.75 11.9393L11.25 14.4393V7H12.75V14.4393L15.25 11.9393L16.3107 13L12 17.3107Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownCircle;
